import { ContentfulSearchFilters } from "@outschool/gql-backend-generated";
import { SearchListingsQueryVariables } from "@outschool/gql-frontend-generated";
import ldIsNil from "lodash/isNil";
import ldOmitBy from "lodash/omitBy";

function toArrayParser<T>(input?: (T | null)[] | null): T[] | undefined {
  return input?.filter((d: T | null): d is T => !!d) ?? undefined;
}

function stringToArrayParser(input?: string | null): string[] | undefined {
  return (
    input
      ?.split(",")
      .map(x => x.trim())
      .filter(d => !!d && d !== "") ?? undefined
  );
}

export function mapContentfulFiltersToSearchFilters(
  input?: Omit<
    ContentfulSearchFilters,
    "_id" | "contentfulMetadata" | "filtersName" | "linkedFrom" | "sys"
  > | null
): SearchListingsQueryVariables["searchFilters"] {
  return ldOmitBy(
    {
      adminTags: toArrayParser(input?.adminTags),
      age: toArrayParser(input?.ages)?.join(","),
      capacityMax: input?.capacityMax,
      capacityMin: input?.capacityMin,
      delivery: toArrayParser(input?.deliveryTypes)?.join(","),
      durationWeeksMax: input?.durationWeeksMax,
      durationWeeksMin: input?.durationWeeksMin,
      endBy: input?.endBy,
      format: toArrayParser(input?.formats)?.join(","),
      gradeLevel: toArrayParser(input?.gradeLevel)?.join(","),
      hasFilledOutUniqueLearningNeeds: input?.hasFilledOutUniqueLearningNeeds,
      multiTermQuery: stringToArrayParser(input?.multiTermQuery),
      q: input?.query,
      pricePerCourseMax: input?.pricePerCourseMax,
      pricePerCourseMin: input?.pricePerCourseMin,
      pricePerMeetingMax: input?.pricePerMeetingMax,
      pricePerMeetingMin: input?.pricePerMeetingMin,
      startAfter: input?.startAfter,
      startBefore: input?.startBefore,
      theme: input?.subject,
      uniqueLearningNeeds: input?.uniqueLearningNeeds,
      weeklyMeetingsMin: input?.weeklyMeetingsMin,
      weeklyMeetingsMax: input?.weeklyMeetingsMax,
    },
    ldIsNil
  );
}
